




import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class WatermarkConponent extends Vue {
    @Prop() private msg!: string

    get displayName() {
        return this.$store.getters.displayName
    }

    get tenantName() {
        return this.$store.getters.tenantName
    }

    mounted(): void {
        this.draw()
    }

    draw(): void {
        const can: HTMLCanvasElement = document.createElement('canvas')
        const body: HTMLElement | null = document.getElementById('watermark')

        if (body) {
            body.appendChild(can)
        }

        can.width = 400
        can.height = 200
        can.style.display = 'none'

        const cans: CanvasRenderingContext2D | null = can.getContext('2d')

        if (cans) {
            cans.rotate((-30 * Math.PI) / 180)
            cans.font = '12px Microsoft JhengHei'
            cans.fillStyle = 'rgba(17, 17, 17, 0.3)'
            cans.textAlign = 'center'
            cans.textBaseline = 'hanging'
            // cans.lineHeight = 400
            cans.fillText(`${this.tenantName} - ${this.displayName}`, can.width / 3, can.height / 2)

            if (body) {
                body.style.background = `url(${can.toDataURL('image/png')}) repeat`
            }
        }
    }
}
